import { render } from "./TransactionListRecent.vue?vue&type=template&id=94d9012c&scoped=true&ts=true"
import script from "./TransactionListRecent.vue?vue&type=script&lang=ts"
export * from "./TransactionListRecent.vue?vue&type=script&lang=ts"

import "./TransactionListRecent.vue?vue&type=style&index=0&id=94d9012c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d9012c"]])

export default __exports__